import { useState } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { label: "Expertise", href: "#expertise" },
  { label: "Company", href: "#company" },
  { label: "Leadership", href: "#leadership" },
  { label: "Our Business", href: "#business" },
  { label: "Culture", href: "#culture" },
  { label: "Partners", href: "#partners" },
];

const slug = (s) => s.toLowerCase().replace(/\s+/g, "-");

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  return (
    <header data-testid="navbar" className="fixed top-0 inset-x-0 z-50 bg-white/85 backdrop-blur-xl border-b border-black/10">
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-16 flex items-center justify-between">
        <a href="#top" data-testid="nav-logo" className="font-heading font-black tracking-tight text-zinc-950 text-lg">
          HARRIS<span className="text-[#00E5FF]"> HOLT</span>
        </a>
        <nav className="hidden lg:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              data-testid={`nav-link-${slug(l.label)}`}
              href={l.href}
              className="text-xs font-bold uppercase tracking-[0.2em] text-zinc-500 hover:text-zinc-950 transition-colors"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#contact"
            data-testid="nav-contact-button"
            className="bg-[#00E5FF] text-black text-xs font-bold uppercase tracking-wider px-5 py-2.5 hover:bg-[#33EAFF] transition-colors"
          >
            Contact Us
          </a>
        </nav>
        <button
          data-testid="nav-mobile-menu-button"
          className="lg:hidden text-zinc-950"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>
      {open && (
        <nav data-testid="nav-mobile-menu" className="lg:hidden bg-white border-t border-black/10 px-6 py-6 flex flex-col gap-5">
          {links.map((l) => (
            <a
              key={l.href}
              data-testid={`nav-mobile-link-${slug(l.label)}`}
              href={l.href}
              onClick={() => setOpen(false)}
              className="text-sm font-bold uppercase tracking-[0.2em] text-zinc-600 hover:text-[#0891B2] transition-colors"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#contact"
            data-testid="nav-mobile-contact-button"
            onClick={() => setOpen(false)}
            className="text-sm font-bold uppercase tracking-[0.2em] text-[#0891B2]"
          >
            Contact Us
          </a>
        </nav>
      )}
    </header>
  );
};
